import React from "react";

interface Props {
}

export class Thanks extends React.PureComponent<Props> {
    public render() {
        return(<div className="center-modal">
            <div><span className="thanks-text">Thanks</span></div>
        </div>);
    }
}
